import { useEffect, useRef, useState } from "react";
// import Banner from "./banner-section";
import Banner from "./banner-section-media";
import "@fancyapps/ui/dist/fancybox.css";
import About_Mosaic from "./about-mosaic";
import { Helmet } from "react-helmet";
import Navbar from "./navbar";
import Footer from "./footer";
import Loading from "./loading";

const Media = () => {
  const [loading, setLoading] = useState(false);
  const videoRef1 = useRef(null);
  const videoRef2 = useRef(null);
  const videoRef3 = useRef(null);
  const videoRef4 = useRef(null);
  const videoRef5 = useRef(null);

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, []);
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>
          Best Mosaic Tiles & Porcelain Tiles Manufacturer - Ignite Mosaic
        </title>
        <meta
          name="description"
          content="Discover excellence in sintered stone with Ignite Mosaic, India's premier manufacturer. Elevate your spaces with our superior Products."
        />
        <link rel="canonical" href="https://ignitemosaic.com/media"></link>
      </Helmet>
      {loading ? (
        <Loading />
      ) : (
        <>
          <Navbar modalBg="modalbg" />
          <main id="media">
            <Banner data="Media" image="preview/preview_6_800x1200_9_s.jpg" />
            <About_Mosaic />
            <div className="container padding-top">
              <h2 className="h2_heading text-center">
                Customize Size Factory And Mosaic Factory Videos
              </h2>
              <br />
              <div className="row">
                {/* Video 1 */}
                <div className="col-lg-4 col-md-6 mt-lg-0">
                  <div className="video-wrapper">
                    <div className="video-container">
                      <div className="iframe-wrapper">
                        <iframe
                          ref={videoRef1}
                          id="video1"
                          width="100%"
                          height="250"
                          src="https://www.youtube.com/embed/plBSZMA9cgU?enablejsapi=1"
                          frameBorder="0"
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                          allowFullScreen
                        ></iframe>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Video 2 */}
                <div className="col-lg-4 col-md-6 mt-lg-0">
                  <div className="video-wrapper">
                    <div className="video-container">
                      <div className="iframe-wrapper">
                        <iframe
                          ref={videoRef2}
                          id="video2"
                          width="100%"
                          height="250"
                          src="https://www.youtube.com/embed/MvgZJBxxl4k?enablejsapi=1"
                          frameBorder="0"
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                          allowFullScreen
                        ></iframe>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Video 3 */}
                <div className="col-lg-4 col-md-6 mt-lg-0">
                  <div className="video-wrapper">
                    <div className="video-container">
                      <div className="iframe-wrapper">
                        <iframe
                          ref={videoRef3}
                          id="video3"
                          width="100%"
                          height="250"
                          src="https://www.youtube.com/embed/gdMoh3myM7M?enablejsapi=1"
                          frameBorder="0"
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                          allowFullScreen
                        ></iframe>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Video 4 */}
                <div className="col-lg-4 col-md-6 mt-lg-0">
                  <div className="video-wrapper">
                    <div className="video-container">
                      <div className="iframe-wrapper">
                        <iframe
                          ref={videoRef4}
                          id="video4"
                          width="100%"
                          height="250"
                          src="https://www.youtube.com/embed/gdMoh3myM7M?enablejsapi=1"
                          frameBorder="0"
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                          allowFullScreen
                        ></iframe>
                      </div>
                    </div>
                  </div>
                </div>

                {/* https://www.youtube.com/watch?v=_vT-V_HxdLM */}
                {/* Video s */}
                <div className="col-lg-4 col-md-6 mt-lg-0">
                  <div className="video-wrapper">
                    <div className="video-container">
                      <div className="iframe-wrapper">
                        <iframe
                          ref={videoRef5}
                          id="video4"
                          width="100%"
                          height="250"
                          src="https://www.youtube.com/embed/_vT-V_HxdLM?si=k14bQllvqDepgjDC"
                          frameBorder="0"
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                          allowFullScreen
                        ></iframe>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </main>
          <Footer />
        </>
      )}
    </>
  );
};

export default Media;
